<div class="risk-trends-card">
    <div class="risk-trends-card-header">
        <div class="risk-trends-card-title">{{'new_entries.risk_distribution' | translate}}</div>
        <div class="risk-trends-card-subtitle">
            {{'new_entries.monthly_breakdown_of_student_submissions_by_originality_risk_level' | translate }}</div>

    </div>
    <div class="risk-trends-chart-placeholder" style="background: none; padding: 0;">
        <div *ngIf="errorMessage" class="risk-trends-error">{{ errorMessage }}</div>
        <apx-chart *ngIf="!errorMessage && chartOptions" [series]="chartOptions.series" [chart]="chartOptions.chart"
            [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis" [colors]="chartOptions.colors"
            [stroke]="chartOptions.stroke" [dataLabels]="chartOptions.dataLabels" [legend]="chartOptions.legend"
            [tooltip]="chartOptions.tooltip" [grid]="chartOptions.grid" [responsive]="chartOptions.responsive"
            style="width: 100%; min-width: 0;">
        </apx-chart>

    </div>
</div>